import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    noDataContainer: {
        padding: theme.spacing(2, 0),
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        boxShadow: `0 -5px 3px -3px ${theme.palette.grey[200]} inset, 0 5px 3px -3px ${theme.palette.grey[200]} inset`
    }
}));